import { useEffect, useState } from "react";
import { useMyProviderDataClient } from "../../../../context/ApiContext";

export interface LOAResult {
  data?: string[][];
  loading: boolean;
  error?: string;
}

export const useLeaveOfAbsence = (
  username?: string,
  year?: string,
  quarter?: number,
  enabled: boolean = true
): LOAResult => {
  const client = useMyProviderDataClient();

  const [data, setData] = useState<string[][]>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string>();

  useEffect(() => {
    if (!enabled || !username || !year) return;

    const load = async () => {
      try {
        setLoading(true);
        setError(undefined);

        const res = await client.get(
          "/EmployeeInformation/LOADates",
          { params: { username, year, quarter } }
        );

        const result = res.data;

        // console.log("Leave of Absence API result:", result);
        // if (!Array.isArray(result) || result.length === 0) {
        //   setData(undefined);
        //   return;
        // }

        // const formatted = result.map((item: any) => [
        //   new Date(item.leaveofAbsenceStartDate).toLocaleDateString(),
        //   new Date(item.leaveofAbsenceEndDate).toLocaleDateString(),
        // ]);

        const formatted = new Array<string[]>();
        if(result.leaveofAbsenceStartDate && result.leaveofAbsenceEndDate){
            formatted.push([
                new Date(result.leaveofAbsenceStartDate).toLocaleDateString(),
                new Date(result.leaveofAbsenceEndDate).toLocaleDateString(),
            ]);
        }
        setData(formatted);
      } catch (err) {
        console.error(err);
        setError("Failed to load Leave of Absence.");
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [username, year, quarter, enabled, client]);

  return { data, loading, error };
};